import { inject, Injectable } from '@angular/core';
import { ToasterMessageService } from '../topbar-toaster/toaster-message.service';
import { IVRQueueAlertResponse } from '../../../care-manager-portal/service/signalR/signal-r.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationServiceService {
  public toastService = inject(ToasterMessageService);
  private audio = new Audio('assets/caregenix/audio/notification.mp3');

  requestPermission() {
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications.');
      return;
    }
    if (Notification.permission === 'default') {
      Notification.requestPermission().then((permission) => {
        console.log('Notification permission:', permission);
      });
    } else {
      console.log('Notification permission already:', Notification.permission);
    }
  }

  showNotification(message: string) {
    this.audio.play();
    this.toastService.successMessage("Patient Added in Np Dashboard.", true);
    if (Notification.permission === 'granted') {
      new Notification('New Message', {
        body: "Patient Added in Np Dashboard.",
        icon: 'assets/icon.png',
      });
    }
  }
  showNotificationCritical(message: string) {
    this.audio.play();
    this.toastService.successMessage(message, true);
    if (Notification.permission === 'granted') {
      new Notification('New Message', {
        body: message,
        icon: 'assets/icon.png',
      });
    }
  }
  showNotificationWithIds(data:any) {
    const userIds = Array.from(
      new Set(data.flatMap((item:any) => item.userids))
    );
    const raw = localStorage.getItem('userSettings');
    if (raw) {
      const settings: any = JSON.parse(raw);
      const id = settings?.userInfo?.id;
      if (userIds.includes(id)) {
        this.audio.play();
        this.toastService.successMessage(data[0].displayText, true);
        if (Notification.permission === 'granted') {
          new Notification('New Message', {
            body: data[0].displayText,
            icon: 'assets/icon.png',
          });
        }
      }
    }
  }
  showNotificationWithIdForIvrQueue(data:any) {

    const userIds =data.map((item:any) => (item.userId));
    const raw = localStorage.getItem('userSettings');
    if (raw) {
      const settings: any = JSON.parse(raw);
      const id = settings?.userInfo?.id;
      if (userIds.includes(id)) {
        this.audio.play();
        this.toastService.successMessage(data[0].displayText, true);
        if (Notification.permission === 'granted') {
          new Notification('New Message', {
            body: data[0].displayText,
            icon: 'assets/icon.png',
          });
        }
      }
    }
  }
}
